import React from 'react';

import { useIntl } from 'react-intl';

import { useFeatureOffers } from 'components/offers/ui-refresh/use-feature-offers';

import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateImage,
  EmptyStateTitle,
} from './favorite-empty-state.styled';

const FavoriteEmptyState = () => {
  const { formatMessage } = useIntl();
  const { featureOffersLoading, featureOffers } = useFeatureOffers();

  if (featureOffersLoading || !featureOffers) {
    return null;
  }

  return (
    <EmptyState>
      <EmptyStateImage
        image={featureOffers.offersBrowsingPanel?.emptyStateImage}
        alt=""
        objectFitContain
      />
      <EmptyStateTitle>{formatMessage({ id: 'offerFavoriteEmptyStateTitle' })}</EmptyStateTitle>
      <EmptyStateDescription>
        {formatMessage({ id: 'offerFavoriteEmptyStateDescription' })}
      </EmptyStateDescription>
    </EmptyState>
  );
};

export default FavoriteEmptyState;
